import React from "react";
import { Navigate } from "react-router-dom";

export default function PublicRoutes({ children, restricted }) {
  const isAuthenticated = false;
  //   const isAuthenticated = localStorage.getItem('authToken'); // Example auth check

  return isAuthenticated && restricted ? (
    <Navigate to="/dashboard" />
  ) : (
    children
  );
}
